import { render, staticRenderFns } from "./jobdetail.vue?vue&type=template&id=3f17dfd4&"
import script from "./jobdetail.vue?vue&type=script&lang=js&"
export * from "./jobdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports